import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Alert } from "react-bootstrap";
import { authService } from "../../../Services/auth.service";
import { FaSignInAlt } from "react-icons/fa";
import { ImSpinner9 } from "react-icons/im";

export default function Reset(props) {
    const { t } = useTranslation();
    const { keypass } = useParams();
    const navigate = useNavigate();
    const [alertShow, setAlertShow] = useState({ show: false, message: "" });
    const [pass, setPass] = useState('')
    const [confirmPass, setConfirmPass] = useState('')
    const [buttonLoading, setButtonLoading] = useState(false);
    const [passReseted, setPassReseted] = useState(false)

    const validate = () => {
        if (!confirmPass || !pass) {
            setAlertShow({
                show: true,
                message: t("ERRORS.REQUIRED_FIELDS"),
            });
            return false;
        }

        if(confirmPass !== pass) {
            setAlertShow({
                show: true,
                message: t("ERRORS.CONFIRM_PASS"),
            });
            return false;
        }

        if(!keypass) {
            setAlertShow({
                show: true,
                message: t("ERRORS.KEY_PASS_INVALID"),
            });
            return false;
        }
        return true;
    };

    const reset = async () => {
        if(!validate()) return

        try {
            var payload = {
                keyPass: keypass,
                pass: pass,
            };

            setButtonLoading(true);
            var response = await authService.resetPass(payload);

            if (response) {
                setPassReseted(true)
            } else {
                setAlertShow({
                    show: true,
                    message: t("ERRORS.RESET_NOT_POSSIBLE"),
                });
            }
        } catch (error) {
            setAlertShow(true);
            console.log(error);
        } finally {
            setButtonLoading(false);
            props.onLoading(false);
        }
    };

    const goLogin = () => {
        navigate("/");
    }

    return (
        <React.Fragment>
            <div className='no-loading'>
                <span
                className='login100-form-title p-b-43'
                style={{ color: "#00698B" }}>
                    {" "}
                    {t("LOGIN.RESET_PASSWORD")}
                </span>

                <Alert variant='danger' style={alertShow.show ? { display: "block" } : { display: "none" }}>
                    <strong>{t("COMMON.ATTENTION")}</strong>
                    <p>{alertShow.message}</p>
                </Alert>

                {!passReseted ? (
                    <>
                        <div className='wrap-input100 validate-input'>
                            <input
                                className='input100 input-pass'
                                type='text'
                                name='pass'
                                value={pass}
                                onChange={(e) => {
                                    setAlertShow({ show: false, message: "" });
                                    setPass(e.target.value)
                                }}
                                autoComplete='off'
                            />
                            <span className='focus-input100'></span>
                            <span className='label-input100'>{t("LOGIN.NEW_PASSWORD")}</span>
                        </div>

                        <div className='wrap-input100 validate-input'>
                            <input
                                className='input100'
                                type='text'
                                name='confirmPass'
                                value={confirmPass}
                                autoComplete='off'
                                onChange={(e) => {
                                    setAlertShow({ show: false, message: "" });
                                    setConfirmPass(e.target.value)
                                }}
                            />
                            <span className='focus-input100'></span>
                            <span className='label-input100'>{t("LOGIN.CONFIRM_PASSWORD")}</span>
                        </div>

                        <div className='container-login100-form-btn'>
                            <button
                                className='login100-form-btn'
                                type='button'
                                onClick={reset}
                                disabled={buttonLoading}
                            >
                                <>
                                    {buttonLoading && (
                                        <ImSpinner9
                                            className='icon-spin'
                                            style={{ marginRight: "10px" }}
                                        />
                                    )}
                                    {!buttonLoading && (
                                        <FaSignInAlt style={{ marginRight: "10px" }} />
                                    )}
                                </>
                                <span>{buttonLoading ? t("LOGIN.RESETTING") : t("LOGIN.RESET")}</span>
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <Alert variant='success'>
                            <strong>{t("LOGIN.PASSWORD_UPDATED_SUCCESS")}</strong>
                            <p>{t("LOGIN.GO_TO_LOGIN_TEXT")}</p>
                        </Alert>
                        <div className='container-login100-form-btn'>
                            <button
                                className='login100-form-btn'
                                type='button'
                                onClick={goLogin}
                            >
                                <FaSignInAlt style={{ marginRight: "10px" }} />
                                <span>{t("LOGIN.GO_TO_LOGIN")}</span>
                            </button>
                        </div>
                    </>
                )}
            </div>
        </React.Fragment>
    );
}